import { render, staticRenderFns } from "./paymentPage.vue?vue&type=template&id=5a959747&"
import script from "./paymentPage.vue?vue&type=script&lang=js&"
export * from "./paymentPage.vue?vue&type=script&lang=js&"
import style0 from "./paymentPage.vue?vue&type=style&index=0&id=5a959747&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports